import {useQuery} from "react-query";
import {getAxios} from "../../axios/generic-api-calls";
import {PageModel, PagePaginatedModel} from "./pageTypes";

export function useFetchPages(key:string = 'pages') {
    return useQuery<PagePaginatedModel>(key, () => getAxios('/page'));
}

export function useFetchPageByIdOrSlug(idOrSlug:string, key:string = 'page') {
    return useQuery<PageModel>(key, () => getAxios(`/page/${idOrSlug}`));
}
